/**
 * AUTO-GENERATED by scripts/generate-cvent-plan.mjs — DO NOT EDIT BY HAND.
 *
 * Source of truth: src/analytics/cvent/actions/*.json.
 * Regenerate with: pnpm attendee-activities:generate-plan
 */
import { Action, type AttendeeActivitiesActionProps } from '@cvent/analytics/Action';

/**
 * Props for the "poll answer submitted" Attendee Activities fact.
 *
 * Extends `AttendeeActivitiesActionProps`, which requires `objectId`. For this
 * fact the `objectId` mirrors `sessionId`.
 */
export interface PollAnswerSubmittedProps extends AttendeeActivitiesActionProps {
  /** Cvent session identifier (from event/getCventIdentity). */
  sessionId: string;

  /** Identifier of the poll voted on. In Goldcast a poll contains exactly one question, so this equals questionId. */
  pollId: string;

  /** Identifier of the poll question. Mirrors pollId because a Goldcast poll has a single question (the backend schema keeps both for Cvent-side multi-question polls). */
  questionId: string;

  /** 'singleChoice' or 'multipleChoice'. */
  questionType: 'singleChoice' | 'multipleChoice';

  /** Answer id the attendee submitted (comma-joined ids for multiple choice). */
  submittedAnswer: string;
}

/**
 * `@cvent/analytics` Action model for the "poll answer submitted" fact.
 *
 * The `id` is the Attendee Activities `activity_type`. Routing is not set per action — the
 * singleton's `defaultDestinations` (`CVENT_ANALYTICS_DESTINATIONS`) routes
 * every fact, matching `../actions/poll_answer_submitted.json`.
 *
 * @description Tracks when an attendee submits a poll answer during a Goldcast session, publishing to the Cvent Attendee Activities pipeline to build a unified record of attendee engagement.
 * @trigger Fired when an attendee submits or updates a vote.
 */
export default class PollAnswerSubmitted extends Action<PollAnswerSubmittedProps> {
  id = 'session.poll_answer_submitted';
}
